export default "__VITE_ASSET__Cpt$XZVN__"